declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    dataLayer: any;
  }
}

class GoogleTagManagerService {
  existDataLayer = () => typeof window.dataLayer !== 'undefined';

  /**
   * Push an event when bread modal is opened
   */
  dataLayerBreadModalOpen() {
    if (this.existDataLayer()) {
      window.dataLayer.push({
        event: 'breadModalOpen'
      });
    }
  }

  /**
   * Push an event when bread modal is closed
   *
   *  @param {string} breadStatus Customer state from Bread
   */
  dataLayerBreadModalClose(breadStatus: string) {
    if (this.existDataLayer()) {
      window.dataLayer.push({
        event: 'breadModalClose',
        breadStatus
      });
    }
  }

  /**
   * Push Event on error view
   *
   * @param {String} errorMessage
   * @param {String} formName
   * @param {String} formField
   */
  dataLayerErrorViewed(
    errorMessage: string,
    formName: string,
    formField: string
  ) {
    if (this.existDataLayer()) {
      window.dataLayer.push({
        event: 'errorViewed',
        errorMessage,
        formName,
        formField
      });
    }
  }

  /**
   * Push an event when when email is submitted for subscription
   */
  dataLayerEmailSubmitted() {
    if (this.existDataLayer()) {
      window.dataLayer.push({
        event: 'emailSubmitted'
      });
    }
  }

  /**
   * Push an event when map search is performed
   *
   * @param {String} value Search term
   */
  dataLayerMapSearch(value: string) {
    if (this.existDataLayer()) {
      window.dataLayer.push({
        event: 'zip_code_submit',
        value
      });
    }
  }
}

export default new GoogleTagManagerService();
